import { Tooltip } from "@mui/material";
import { CLIENT_VIEW_READ_ONLY_TOOLTIP } from "hooks/useViewAs";

interface ReadOnlyTooltipProps {
  /** When false the children render untouched. */
  active: boolean;
  title?: string;
  placement?: "top" | "bottom" | "left" | "right" | "bottom-end";
  children: React.ReactElement;
}

// MUI swallows events on a disabled element, so the tooltip needs a plain
// wrapper to hang off.
export default function ReadOnlyTooltip({
  active,
  title,
  placement = "top",
  children,
}: ReadOnlyTooltipProps) {
  if (!active) return children;
  return (
    <Tooltip
      title={title ?? CLIENT_VIEW_READ_ONLY_TOOLTIP}
      placement={placement}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
}
